import {settingsEpics} from './Settings/settingsEpics'

export const adminEpics = [settingsEpics].flatMap(epic => epic)
